'use client';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
export const useNavigationState = ()=>{
    const _pathname = usePathname();
    const [activeLevel, setActiveLevel] = useState(-1);
    const setNavigationLevel = (level)=>{
        setActiveLevel((prev)=>prev === level ? -1 : level);
    };
    useEffect(()=>{
        setActiveLevel(-1);
    }, []);
    return {
        activeLevel,
        setNavigationLevel
    };
};

//# sourceMappingURL=use-navigation-state.js.map